export default __webpack_public_path__ + "static/media/Monk's Threads of the Underworld.223ba0e4.jpg";